import PropTypes from 'prop-types'
import {StandaloneDagger} from '../common/Dagger'
import {StyledInfoBanner} from '../PersonaSidebar/Styles'

const ZeroPopulationBanner = ({message = 'No populations match the selected criteria.'}) => {
  return (
    <StyledInfoBanner>
      <StandaloneDagger width={20} height={20} /> &nbsp;{message}
    </StyledInfoBanner>
  )
}

ZeroPopulationBanner.propTypes = {
  message: PropTypes.string
}

export default ZeroPopulationBanner
